export const ACCESSIBILITY_TAGS = [
  {
    tag: "autism",
    short: "Autisme",
    long: "Autisme"
  },
  {
    tag: "lvb",
    short: "LVB",
    long: "Licht verstandelijk beperkt"
  },
  {
    tag: "mvb",
    short: "MVB",
    long: "Meervoudig verstandelijk beperkt"
  },
  {
    tag: "psychological",
    short: "Psych. klachten",
    long: "Psychische klachten"
  },
  {
    tag: "wheelchair",
    short: "Rolstoelgebonden",
    long: "Rolstoelgebonden"
  },
  {
    tag: "adult",
    short: "Volwassen",
    long: "Volwassenen"
  },
  {
    tag: "child",
    short: "Kind",
    long: "Kinderen"
  }
];
